import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { SearchInputOption } from "../../../shared/components/search-bar/search-input/search-input.component";
import { AnyObject } from "../../../shared/types/app.type";
import { UserInfo } from "../../../shared/types/user-info";
import { setFilterCondition } from "../../../shared/utils/helpers/common.helper";
import { CompanyService } from "../companies/company.service";
import { PartnerService } from "../partners/partner.service";
import { Quote } from "./quote.type";

//#region Search Filter Options

export const getQuoteSearchFilterOptions = (
  user: UserInfo,
  config?: {
    shown?: string[];
    hidden?: string[];
    partnerService?: PartnerService;
    companyService?: CompanyService;
  },
): SearchFilterOption<Quote>[] => {
  const { shown, hidden, partnerService, companyService } = config || {};

  return (
    [
      { value: "name", label: "Name" },
      {
        value: "number",
        label: "Quote #",
      },
      {
        auxValue: "partnerId",
        value: "company.partner.name",
        label: "Partner",
        inputType: "dropdown",
        condition: "$eq",
        hidden: !user.isGlobal() || !partnerService,
        filterByProperty: { company: { partnerId: true } },
        asyncOptions: ({ queryParams }) =>
          partnerService.getSearchablePartners({
            where: {
              ...(queryParams && { ...setFilterCondition(queryParams as AnyObject, "$cont") }),
            },
          }),
        search: {
          callback: ({ queryParams }) =>
            partnerService.getSearchablePartners({
              where: {
                ...(queryParams && {
                  ...setFilterCondition(queryParams as AnyObject, "$cont"),
                }),
              },
            }),
        },
      },
      {
        auxValue: "companyId",
        value: "company.name",
        label: "Company",
        inputType: "dropdown",
        condition: "$eq",
        hidden: user.isCompanyOrViewAsCompany() || !companyService,
        asyncOptions: ({ queryParams }) =>
          companyService.getSearchableCompany({
            where: {
              ...(queryParams && { ...setFilterCondition(queryParams as AnyObject, "$cont") }),
            },
          }),
        search: {
          callback: ({ queryParams }) =>
            companyService.getSearchableCompany({
              where: {
                ...(queryParams && {
                  ...setFilterCondition(queryParams as AnyObject, "$cont"),
                }),
              },
            }),
        },
      },
    ] as SearchFilterOption<Quote>[]
  ).filter((opt) => (shown ? shown.includes(opt.value) : true) && (hidden ? !hidden.includes(opt.value) : true));
};

//#endregion

//#region Search Input Options

export const quoteTypes: SearchInputOption[] = [
  { value: "oem", label: "OEM" },
  { value: "third party", label: "Third Party" },
  { value: "warranty", label: "Warranty" },
  { value: "software", label: "Software" },
];

//#endregion
